import React from 'react'
import {
  Typography as MTypography,
  TypographyProps as MTypographyProps,
  Box
} from '@material-ui/core'

export type TypographyProps = MTypographyProps & {
  fontWeight?: number
}

export default function Typography ({ fontWeight, variant, children, ...props }: TypographyProps) {
  if (!fontWeight) {
    return (
      <MTypography
        {...props}
        variant={variant || 'body1'}
      >
        {children}
      </MTypography>
    )
  }

  return (
    <MTypography
      {...props}
      variant={variant || 'body1'}
    >
      <Box
        component="span"
        fontWeight={fontWeight}
      >
        {children}
      </Box>
    </MTypography>
  )
}
